import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RentReservationService {
  selectedReservationDetails = new BehaviorSubject({});

  constructor(private http: HttpClient) {}

  createRentReservation(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/rent-bookings/create`, payload);
  }

  updateRentReservation(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/rent-bookings/update`, payload);
  }

  updateRentReservationFuelAndMileageData(payload: any): Observable<any> {
    return this.http.put(
      `${SETTINGS.BASE_API}/rent-bookings/update/fuel-mileage`,
      payload,
    );
  }

  getReservationInDetail(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/rent-bookings/in-details/${id}`);
  }

  getReservationById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/rent-bookings/${id}`);
  }

  getPagedReservations(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/rent-bookings/get-paged`,
      payload,
    );
  }
  getAllPagingBoardDataReservations(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/rent-bookings/get-paging`,
      payload,
    );
  }
}
